import LearnPageLayout from "@/components/LearnPageLayout";
import { saintFortLauderdale } from "./learnDataSaintFortLauderdale";

const SaintFortLauderdalePage = () => (
  <LearnPageLayout
    title={saintFortLauderdale.title}
    description={saintFortLauderdale.description}
    canonical={saintFortLauderdale.canonical}
    h1={saintFortLauderdale.h1}
    breadcrumbLabel={saintFortLauderdale.breadcrumbLabel}
    crumbs={saintFortLauderdale.crumbs}
    shortAnswer={saintFortLauderdale.shortAnswer}
    keyTakeaways={saintFortLauderdale.keyTakeaways}
    sections={saintFortLauderdale.sections}
    faqs={saintFortLauderdale.faqs}
    sources={saintFortLauderdale.sources}
    schemaJson={saintFortLauderdale.schemaJson}
    relatedLinks={saintFortLauderdale.relatedLinks}
    reviewBlock={saintFortLauderdale.reviewBlock}
  />
);

export default SaintFortLauderdalePage;
